import { render, staticRenderFns } from "./BasketIcon2.vue?vue&type=template&id=7e0032c7"
import script from "./BasketIcon2.vue?vue&type=script&lang=js"
export * from "./BasketIcon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports